export default "<div> <h5>Shop: {{vm.shop.name}}</h5> <table class=history-t ng-if=\"vm.defects && vm.defects.length\"> <thead> <tr> <th>Defect</th> <th>Instances</th> </tr> </thead> <tbody> <tr ng-repeat=\"defect in vm.defects | orderBy:['-count','severity']\" style=cursor:auto> <td>{{ defect.defectTypeName }} <span ng-if=defect.defectTypeLegacyId>[{{ defect.defectTypeLegacyId }}]</span></td> <td>{{ defect.count }}</td> </tr> </tbody> </table> <div ng-if=\"!vm.defects || !vm.defects.length\">No Defects</div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/controllers/dashboard/topDefects.tpl.html
// module id = 526
// module chunks = 0